function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0054 11V20.4C19.0054 20.7314 18.7368 21 18.4054 21H3.60537C3.274 21 3.00537 20.7314 3.00537 20.4V11",
  stroke: "#1A1A1A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4049 6H1.60488C1.27351 6 1.00488 6.26863 1.00488 6.6V10.4C1.00488 10.7314 1.27351 11 1.60488 11H20.4049C20.7363 11 21.0049 10.7314 21.0049 10.4V6.6C21.0049 6.26863 20.7363 6 20.4049 6Z",
  stroke: "#1A1A1A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0049 21V6",
  stroke: "#1A1A1A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0044 6H6.50439C5.84135 6 5.20546 5.73661 4.73662 5.26777C4.26778 4.79893 4.00439 4.16304 4.00439 3.5C4.00439 2.83696 4.26778 2.20107 4.73662 1.73223C5.20546 1.26339 5.84135 1 6.50439 1C10.0044 1 11.0044 6 11.0044 6Z",
  stroke: "#1A1A1A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0049 6H15.5049C16.1679 6 16.8038 5.73661 17.2727 5.26777C17.7415 4.79893 18.0049 4.16304 18.0049 3.5C18.0049 2.83696 17.7415 2.20107 17.2727 1.73223C16.8038 1.26339 16.1679 1 15.5049 1C12.0049 1 11.0049 6 11.0049 6Z",
  stroke: "#1A1A1A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgGift = function SvgGift(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGift, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gift_.92e703ac.svg";
export { ForwardRef as ReactComponent };